import './scss/style.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import App from './app/index.vue';
import Vue from 'vue';
import AppCore from '../plugin';
import * as Sentry from "@sentry/vue";

import BootstrapVue from 'bootstrap-vue';

import i18next from './i18n';
import I18NextVue from "i18next-vue";

import router from './router';
import store from './store';
import ToastService from '../plugin/services/toast.service';
import VModal from 'vue-js-modal';
import Vuelidate from 'vuelidate';
import VueCurrencyInput from 'vue-currency-input';

import VueMoment from 'vue-moment';

import { setEntityConfig } from '../plugin/services/configuration.service';

import WindowInstaller from './plugins/kendoFloatWindow';

import moment from 'moment-timezone';
require('moment/locale/es');
moment.tz.setDefault('Europe/Madrid');

setEntityConfig(store).then(() => {
  Vue.use(AppCore, { router });

  Vue.use(VModal, {
    resizable: true,
    scrollable: true,
    dynamic: true,
    injectModalsContainer: true,
    componentName: 'peak-popup'
  });

  Vue.use(BootstrapVue);
  Vue.use(Vuelidate);
  Vue.use(WindowInstaller);

  Vue.use(VueMoment, { moment });
  Vue.use(VueCurrencyInput, { globalOptions: { currency: 'EUR', locale: 'es' } });

  // Toast Service
  Vue.use(ToastService);

  Vue.config.productionTip = false;

  /* Register v-scroll directive */
  Vue.directive('scroll', {
    inserted(el, binding) {
      const handleScroll = function(evt) {
        if (binding.value(evt, el)) {
          el.removeEventListener('scroll', handleScroll);
        }
      };

      el.addEventListener('scroll', handleScroll, el);
    }
  });

  Vue.use(I18NextVue, { i18next });

  if (process.env.NODE_ENV !== 'dev' && process.env.NODE_ENV !== 'local' && process.env.NODE_ENV !== 'development' && process.env.VUE_APP_ENV !== 'development' && process.env.VUE_APP_ENV !== 'staging' && process.env.VUE_APP_ENV !== 'develop') {
    Sentry.init({
      Vue,
      dsn: "https://3bba0cffb63b58fc5252c3a77916a896@o4508755123240960.ingest.de.sentry.io/4509509119574096",
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
      ignoreErrors: ['NavigationDuplicated', 'Avoided redundant navigation to current location', 'Redirected when going from', 'Navigation cancelled from']
    });
  }

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
});
